import { render, staticRenderFns } from "./managerList.vue?vue&type=template&id=4a2ad87c&scoped=true&"
import script from "./managerList.vue?vue&type=script&lang=js&"
export * from "./managerList.vue?vue&type=script&lang=js&"
import style0 from "./managerList.vue?vue&type=style&index=0&id=4a2ad87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2ad87c",
  null
  
)

export default component.exports